import axios from "axios";
import { API_KEY, BASE_URL, getAxiosConfig } from "../components/interface/Config";

import { URLS } from './url.constants';
import { useNavigate } from 'react-router-dom';

export const loginUser = async (username: string, password: string) => {
  const url = `${BASE_URL}/${URLS.auth.login}`;
  try {
    const payload = {
      username,
      password,
      role: "provider",
    }
    const response   = await apiHandler('', 'POST',payload, url);

    // const response = await axios.post(
    //   url,
    //   {
    //     username,
    //     password,
    //     role: "provider",
    //   },
    //   {
    //     headers: {
    //       "x-api-key": API_KEY,
    //     },
    //   },
    // );

    // Log the entire response data for debugging

    if (!response) {
      throw new Error("No response received from the server");
    }

    console.log("API Response:", response);

    // Log the status code and response data
    console.log("Response Status:", response.status);
    console.log("Response Data:", response.data);
    sessionStorage.setItem("authResponse", JSON.stringify(response.data));
    console.log("Response data stored in sessionStorage:", response.data);
    // Extract token from headers
    const token = response.headers["authorization"];

    if (token) {
      // If token exists, store it in sessionStorage
      sessionStorage.setItem("authToken", token);
      console.log("Token stored in sessionStorage:", token);
    }
    
    // if((response.data.code === 200 || response.data.code === 201 ) 
    //     && (response.data.data.is_2fa == 1 || response.data.data.is_2fa == true))  { // Check if 2FA is enabled
    //   // not an error, but 2FA is enabled
    // }else {
    //   // Handle the case where no token is found
    //   console.error("Error: No token found in the response headers");
    //   throw new Error("No token found in the response headers.");
    // }

    return response.data; // Return the entire response or just the token if needed
  } catch (error) {
    // Enhanced error logging
    if (axios.isAxiosError(error)) {
      console.error("Error Response:", error.response); // Logs the response if it exists
      console.error("Error Message:", error.message); // Logs the error message
      console.error("Error Code:", error.code); // Logs any error code if available
    } else {
      console.error("Unexpected Error:", error); // Logs any non-Axios related errors
    }
    throw error; // Re-throws the error after logging it
  }
};


export const login2FAUser = async (username: string, password: string, 
    UserType: string, UserAction: string, UserVerifyMode: string, otp: string) => {

  const url = `${BASE_URL}/${URLS.auth.otpVerfiy}`;
  try {

    const payload = {
      username,
      password,
      action:UserAction,
      // verify_mode : UserVerifyMode,
      otp,
      role: "provider",
    }

    const response   = await apiHandler('', 'POST',payload, url);

    if (!response) {
      throw new Error("No response received from the server");
    }

    // const response = await axios.post(
    //   url,
    //   {
    //     username,
    //     password,
    //     action:UserAction,
    //     verify_mode : UserVerifyMode,
    //     otp,
    //     role: "provider",
    //   },
    //   {
    //     headers: {
    //       "x-api-key": API_KEY,
    //     },
    //   },
    // );

    // Log the entire response data for debugging
    console.log("API Response:", response);

    // Log the status code and response data
    console.log("Response Status:", response.status);
    console.log("Response Data:", response.data);
    sessionStorage.setItem("authResponse", JSON.stringify(response.data));
    console.log("Response data stored in sessionStorage:", response.data);
    // Extract token from headers
    const token = response.headers["authorization"];

    if (token) {
      // If token exists, store it in sessionStorage
      sessionStorage.setItem("authToken", token);
      console.log("Token stored in sessionStorage:", token);
    }else if((response.data.code === 200 || response.data.code === 201 ) 
        && (response.data.data.is_2fa == 1 || response.data.data.is_2fa == true))  { // Check if 2FA is enabled
      // not an error, but 2FA is enabled
    }else {
      // Handle the case where no token is found
      console.error("Error: No token found in the response headers");
      throw new Error("No token found in the response headers.");
    }

    return response.data; // Return the entire response or just the token if needed
  } catch (error) {
    // Enhanced error logging
    if (axios.isAxiosError(error)) {
      console.error("Error Response:", error.response); // Logs the response if it exists
      console.error("Error Message:", error.message); // Logs the error message
      console.error("Error Code:", error.code); // Logs any error code if available
    } else {
      console.error("Unexpected Error:", error); // Logs any non-Axios related errors
    }
    throw error; // Re-throws the error after logging it
  }
};

export const requestWhatsAppOTP = async (mobile: string, isdCode: string = "+91") => {
  const url = `${BASE_URL}/${URLS.auth.login}`;
  try {
    const payload = {
      mobile,
      isd_code: isdCode,
      role: "provider",
    };
    const response = await apiHandler('', 'POST', payload, url);
    if (!response) {
      throw new Error("No response received from the server");
    }
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Error Requesting WhatsApp OTP:", error.response?.data || error.message);
    }
    throw error;
  }
};

export const loginWhatsAppOTP = async (
  mobile: string,
  otp: string,
  isdCode: string = "+91"
) => {
  const url = `${BASE_URL}/${URLS.auth.whatsappOtpVerify}`;
  try {
    const payload = {
      mobile,
      isd_code: isdCode,
      role: "provider",
      otp,
    };
    const response = await apiHandler('', 'POST', payload, url);
    if (!response) {
      throw new Error("No response received from the server");
    }

    const resData = response.data;
    const data = resData?.data || {};

    if (resData?.code) {
      sessionStorage.setItem("responseCode", resData.code.toString());
    }

    sessionStorage.setItem("authResponse", JSON.stringify(resData));

    const token = response.headers["authorization"] || data?.token;
    if (token) {
      sessionStorage.setItem("authToken", token);
    }
    if (data?.info) {
      sessionStorage.setItem("userInfo", JSON.stringify(data.info));
    }
    if (data?.token_expiration_time) {
      sessionStorage.setItem("authTokenExpiration", data.token_expiration_time.toString());
    }

    return resData;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Error Verifying WhatsApp OTP:", error.response?.data || error.message);
    }
    throw error;
  }
};

export const useHandleLogout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/');
  };

  return handleLogout;
};

/**
 * Utility function for logging out outside React components
 */
export const handleLogout = () => {
  sessionStorage.clear();
  window.location.href = '/';
};

export const apiHandler = async (token: string, method : string, params: any, url: string) => {
  
  try {
    let response;
    switch (method.toUpperCase()) {
      case 'POST':
      case 'PATCH':
      case 'PUT':
      case 'DELETE':
        response = await axios({
          method: method, 
          url: url,
          ...getAxiosConfig(token),
          data: JSON.stringify(params), 
        });
        break;

      case 'GET':
        response = await axios({
          method: method,
          url: url,
          ...getAxiosConfig(token),
          params: params, 
        });
        break;

      default:
        throw new Error(`Unsupported HTTP method: ${method}`);
      break;
    }
    
    
    const data = response.data;
    // console.log('response', response)
    
    if (!data.code && (Number(data.code) == 500 || data.message == 'Token expired')) {
      handleLogout(); 
      return;  
    }

    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const responseData = error.response.data;
      console.log('error', responseData?.code, responseData?.message, responseData);

      if (responseData?.code && (Number(responseData.code) == 500) 
        && (responseData.message === "Expired token" 
            || responseData.message === 'Token expired')) {
        handleLogout(); 
        return; 
      } else {
        // Extract validation errors if they exist
        const errors = responseData?.data?.errors;
        let errorMessage = responseData?.message;

        if (errors && typeof errors === 'object') {
          if (errors['user.username']) {
            errorMessage = 'UserName Already Exists!';
          } else {
            const errorMsgs: string[] = [];
            for (const key in errors) {
              if (Object.prototype.hasOwnProperty.call(errors, key)) {
                const val = errors[key];
                if (typeof val === 'string') {
                  errorMsgs.push(val);
                } else if (Array.isArray(val)) {
                  errorMsgs.push(...val.filter(v => typeof v === 'string'));
                }
              }
            }
            if (errorMsgs.length > 0) {
              errorMessage = errorMsgs.join(", ");
            }
          }
        }

        const customError = new Error(errorMessage || "Failed to process request");
        (customError as any).response = error.response;
        throw customError;
      }
    } else {
      console.log('error', error);
      throw error;
    }
  }
};